<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" v-shortkey="['esc']" @shortkey="cerrar"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>


            <b-container fluid="">
                <div class="col-sm-12 mt-3">
                    <h3>
                        Solicitudes de descuento
                    </h3>
                </div>
                <div class="col-sm-12 mt-3 mb-3">
                    <div class="marco_listado_descuentos">
                        <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                            <thead>
                                <tr>
                                    <th style="width: 25%;">
                                        Código
                                    </th>
                                    <th style="width: 50%;">
                                        Descripción
                                    </th>
                                    <th style="width: 15%;text-align: center;">
                                        Estado
                                    </th>
                                    <th style="width: 10%;text-align: center;">
                                        ...
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in datos" :key="index">
                                    <td>
                                        {{ item.no_documento }}
                                    </td>
                                    <td>
                                        {{ item.comentarios }}
                                    </td>
                                    <td style="text-align: center;">
                                        {{ item.estado }}
                                    </td>
                                    <td style="text-align: center;">
                                        <button type="button" style="font-size: 10px;"
                                            class="btn btn-sm btn-outline-dark"
                                            @click="abrir_modal_detalle_descuento(item)"><i
                                                class="fas fa-info-circle"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </b-container>
        </div>

    </div>
</template>

<script>
    import { mapActions, mapMutations, mapState } from 'vuex';

    export default {
        name: 'ModalListadoDescuentos',
        computed: {
            ...mapState(['id_empresa_seleccionada', 'datos_usuario'])
        },
        data() {
            return {
                datos: []
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async obtener_registros() {
                let f = {
                    api: `solicitud-descuentos?filters[empresa][$eq][0]=${this.id_empresa_seleccionada}&filters[sucursal][$eq][1]=${this.datos_usuario.sucursal_asignada}&filters[mostrar][$eq][2]=true`
                }

                let r = await this.obtener_data(f)
                this.datos = r
            },
            abrir_modal_detalle_descuento(item) {
                this.set_obj_detalle_descuento(item)
                this.$emit('ocultar_modal_listado')
            },
            cerrar_modal_detalle_descuento() {
            },
            ...mapActions(['obtener_data']),
            ...mapMutations(['set_obj_detalle_descuento'])
        },
        mounted() {
            this.obtener_registros()
        },
    }
</script>

<style>
    .marco_listado_descuentos {
        width: 100%;
        height: 400px;
        overflow: auto;
    }
</style>